import { useSelector } from 'react-redux';
import { Currency } from '../../models';
import { selectUPECurrency } from '../../selectors';

export const useUPECurrency = (): Currency | undefined => {
  const mneCurrency = useSelector(selectUPECurrency);

  return mneCurrency;
};
